mobileSize = 950;

$(document).ready(function(){
  // Reposition General Message
  $('.generalmessage').prependTo('header');

  // Email Signup - Custom
  $('#uc_masterPageWidgets .emailSignup .emailSignupText').text('Sign up for exciting deals and updates from the festival!');
  $('#uc_masterPageWidgets .emailSignup .emailInputField input')
    .attr('value', '')
    .attr('placeholder', 'Email Address');
  $('#uc_masterPageWidgets .emailSignup .emailSubmitButton').text('Subscribe >');
  $('<span class="close-btn">close x</span>').appendTo('#uc_masterPageWidgets');

  $('#uc_masterPageWidgets .close-btn').click(function() {
    $('#uc_masterPageWidgets').hide();
  });

  // Email Signup - Footer
  $('footer .emailSignup .emailSignupText').text('SIGN UP FOR UPDATES!');
  $('footer .emailSignup .emailInputField input')
    .attr('value', '')
    .attr('placeholder', 'Email Address');
  $('footer .emailSignup .emailSubmitButton').text('Subscribe >');

  // Custom Saffire Logo
  $('.saffire_logo').attr('src', FULLCLIENTTHEMEPATH + 'images/saffire.png');

  // Dynamic Hero
  var heroHTML = '<div class="hero-wrapper" style="background-image: url()"></div>';

  function dynamicHero() {
    var image = $('.entityContainer .entityContainerRow.rowIndex-1').find('.TextMediaModule .single-photo img').attr('data-src');
    var title = $('.entityContainer .entityContainerRow.rowIndex-1').find('.TextMediaModule .moduleTitle');
    var imageSrc = image.replace(/(?=[() ])/g, '\\');
    $('.hero-wrapper').css('background-image', 'url(' + imageSrc + ')');
    $('.hero-wrapper').append(title);
  }

  if ($('body').hasClass('custom')) {
    $(heroHTML).prependTo('.wrapper');
    dynamicHero();
  }

  $('.freeFormPriceInputContainer input')
  .attr('value', 'Amt')
  .attr('aria-label', 'Amt')
  .attr('onclick', 'ClearDefaultText(this, "Amt");')

  $('.getUpdatesPageEmailModule .emailSignup .emailInputSubmit').appendTo('.getUpdatesPageEmailModule .emailSignup .emailInputField');

  // Remove siteInfoBannerWidget from DOM
  $('#siteInfoBannerWidget').remove();
});

$(window).load(function(){
  // Cookie Things
  var subscribeBar = $('#uc_masterPageWidgets');

  if (navigator.cookieEnabled && subscribeBar) {
    if (Cookies.get('subscribe')) {
      return false;
    } else {
      Cookies.set('subscribe', 'subscribe', {expires:90});
      subscribeBar.css('display', 'flex');
    }
  }
});